import { colors, fonts } from '../../../styles'

export default {
	container: {
		display: 'flex',
		alignItems: 'center',
		fontFamily: fonts.header,
		marginLeft: 24
	},
	lg: {
		navHeader: {
			color: colors.white,
			marginLeft: 16,
			paddingLeft: 16,
			borderLeft: `1px dashed ${colors.lightGrey}`
		},
		lawIcon: {
			width: 36,
			height: 36,
			minWidth: 36,
			marginTop: 6,
			fill: colors.white
		},
		header: {
			fontSize: 18,
			letterSpacing: '0.4px'
		},
		subHeader: {
			fontSize: 14,
			color: colors.lightGrey
		}
	},
	sm: {
		navHeader: {
			color: colors.white,
			marginLeft: 8,
			paddingLeft: 8,
			borderLeft: `1px dashed ${colors.lightGrey}`
		},
		lawIcon: {
			width: 30,
			height: 30,
			minWidth: 30,
			marginTop: 3,
			fill: colors.white
		},
		header: {
			fontSize: 16,
			letterSpacing: '0.4px'
		},
		subHeader: {
			fontSize: 12,
			color: colors.lightGrey
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/Layout/Logo/styles.js